import { createApp, h } from "vue"
import "@gouvfr/dsfr/dist/dsfr.min.css"
import "@gouvfr/dsfr/dist/utility/utility.min.css"
import "@gouvfr/dsfr/dist/dsfr.module.min.js"
import App from "./app.vue"

import router from "./router.js"

import StateService from "./plugins/state-service.js"
import ThemeService from "./plugins/theme-service.js"

import * as Sentry from "@sentry/vue"
import VueCookies from "vue-cookies"

import "@/styles/aides-jeunes.css"

import MailDirective from "./directives/mail.js"
import SelectOnClickDirective from "./directives/select-on-click.js"

// @ts-ignore
import { iframeResizerContentWindow } from "iframe-resizer"

import "dayjs/locale/fr.js"
import customParseFormat from "dayjs/plugin/customParseFormat"
import dayjs from "dayjs"
import { createPinia } from "pinia"
import "@fontsource/signika"
import "@fontsource/roboto"

const Resizer = {
  install: function () {
    iframeResizerContentWindow
  },
}
const pinia = createPinia()

const app = createApp({
  render: () => h(App),
})

// src/composables/use-lieux.ts calls Sentry.captureMessage() in two places, and
// those calls have never sent anything: the only Sentry.init() in this repo is in
// backend/configure.ts, the express server, which production does not run — the
// deploy is a static bundle on S3. So the frontend has had no error reporting at
// all, and the calls that look like reporting were no-ops.
//
// Gated on a DSN so that stays exactly true until one is configured: set
// VITE_SENTRY_DSN on the deploy jobs to turn it on, per environment. Without it
// nothing initialises and nothing is sent, which is today's behaviour.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN

if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    // this app runs inside an iframe on Rosaly, so the release and environment are
    // the only way to tell one deploy's errors from another's
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "unknown",
  })
}

app.directive("mail", MailDirective)
app.directive("selectOnClick", SelectOnClickDirective)

app.use(Resizer)
app.use(StateService)
app.use(ThemeService)
app.use(VueCookies)

app.config.globalProperties.$filters = {
  capitalize(value: string = "") {
    return value.charAt(0).toUpperCase() + value.slice(1)
  },
}
declare module "vue" {
  export interface ComponentCustomProperties {
    $theme: {
      current: string
      options: {
        title: string
        label: string
        value: string
      }[]
      update(string): void
    }
    $filters: {
      capitalize(string): string
    }
  }
}

dayjs.locale("fr")
dayjs.extend(customParseFormat)

app.use(pinia)
app.use(router)
app.mount(document.body)
